import { Building, Computer, Zap } from "lucide-react";

import { MARKER_COLOR } from "components/CaseMap/mapLayers";
import useCaseMapStore from "stores/useCaseMapStore";

const ENTRIES = [
  { label: "Machine", color: MARKER_COLOR.machine, icon: Computer },
  { label: "Selected", color: MARKER_COLOR.selectedMachine, icon: Computer },
  {
    label: "Event",
    color: MARKER_COLOR.event,
    icon: Zap,
    // Yellow needs dark ink; every other swatch is dark enough for white.
    iconClassName: "tw:text-(--color-charcoal)",
  },
  { label: "Case address", color: MARKER_COLOR.address, icon: Building },
];

/**
 * What the pins mean. Driven off MARKER_COLOR so the swatches cannot drift from
 * the markers they describe, and listing every marker type whether or not it is
 * currently drawn — the toolbar toggle is what gets it out of the way.
 */
export function CaseMapLegend() {
  const legendVisible = useCaseMapStore(s => s.legendVisible);

  if (!legendVisible) return null;

  return (
    <ul
      aria-label="Map legend"
      className="tw:absolute tw:top-3 tw:left-3 tw:flex tw:flex-col tw:gap-1.5 tw:rounded-lg tw:border tw:border-(--color-border) tw:bg-(--color-surface)/90 tw:p-2.5 tw:shadow-md tw:backdrop-blur-sm"
    >
      {ENTRIES.map(({ label, color, icon: Icon, iconClassName }) => (
        <li
          key={label}
          className="tw:flex tw:items-center tw:gap-2 tw:text-xs tw:text-(--color-text-secondary)"
        >
          <span
            aria-hidden
            className="tw:flex tw:size-4 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:text-white tw:ring-1 tw:ring-white"
            style={{ backgroundColor: color }}
          >
            <Icon className={iconClassName} size={10} strokeWidth={2.5} />
          </span>
          {label}
        </li>
      ))}
    </ul>
  );
}
